import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Recovery from './pages/Recovery';
import Dashboard from './pages/Dashboard';
import Device from './pages/Device';
import Profile from './pages/Profile';
import Test from './pages/Test';
import Users from './pages/Users';
import AccessControl from './pages/AccessControl';
import Requests from './pages/Requests';
import Tickets from './pages/Tickets';
import Logs from './pages/LogsList';
import Alerts from './pages/Alerts';
import Settings from './pages/Settings';
import Bill from './pages/Bill';
import Payments from './pages/Payments';
import ModelsSettings from './pages/ModelsSettings';
import Outages from './pages/Outages';
import Subscription from './pages/Subscription';
import { ThemeContextProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import { MonitoringProvider } from './context/MonitoringContext';
import MonitoringGate from './components/MonitoringGate';
import RequireRole from './components/RequireRole';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeContextProvider>
      <Router>
        <NotificationProvider>
          <AuthProvider>
            <MonitoringProvider>
              <Routes>
                <Route path="/" element={<Navigate to="/login" replace />} />
                <Route path="/login" element={<Login />} />
                <Route path="/recovery" element={<Recovery />} />
                <Route path="/dashboard" element={<MonitoringGate><Dashboard /></MonitoringGate>} />
                <Route path="/device/:id" element={<MonitoringGate><Device /></MonitoringGate>} />
                <Route path="/profile/:user_id" element={<Profile />} />
                <Route path="/profile" element={<Navigate to="/profile/default" replace />} />
                <Route path="/test" element={<Test />} />
                <Route path="/users" element={<RequireRole allow={['admin', 'super_admin']}><Users /></RequireRole>} />
                <Route path="/access-control" element={<RequireRole allow={['admin', 'super_admin']}><AccessControl /></RequireRole>} />
                <Route path="/requests" element={<RequireRole allow={['admin', 'super_admin']}><Requests /></RequireRole>} />
                <Route path="/tickets" element={<MonitoringGate><Tickets /></MonitoringGate>} />
                <Route path="/logs" element={<MonitoringGate><Logs /></MonitoringGate>} />
                <Route path="/alerts" element={<MonitoringGate><Alerts /></MonitoringGate>} />
                <Route path="/settings" element={<MonitoringGate><Settings /></MonitoringGate>} />
                <Route path="/bill" element={<Bill />} />
                <Route path="/payments" element={<Payments />} />
                <Route path="/models-settings" element={<RequireRole allow={['admin', 'super_admin']}><ModelsSettings /></RequireRole>} />
                <Route path="/outages" element={<RequireRole allow={['admin', 'super_admin']}><Outages /></RequireRole>} />
                <Route path="/subscription" element={<MonitoringGate><Subscription /></MonitoringGate>} />
              </Routes>
            </MonitoringProvider>
          </AuthProvider>
        </NotificationProvider>
      </Router>
    </ThemeContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
